export default {
    props: {
        pannableKey: {
            type: String,
            kComposite: 'pannable.key'
        }, 
        pannableLock: {
            type: String,
            kComposite: 'pannable.lock'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/Pannable.js